// frontend/src/components/agenda/calendarExport.js
import { createEvent } from 'ics';

/**
 * Baixa arquivo .ics para a sessão na data informada.
 */
export function downloadICS(session, sessionType, students, occurrenceDate) {
  const dateStr = occurrenceDate || session.date;
  const [year, month, day] = dateStr.split('-').map(Number);
  const [hour, minute] = session.time.split(':').map(Number);
  const title = session.title || sessionType?.name || 'Sessão';
  const description = students.map(s => s.name).join(', ');

  createEvent(
    {
      start: [year, month, day, hour, minute],
      duration: { minutes: Number(session.durationMin) || 60 },
      title,
      description,
      status: 'CONFIRMED',
    },
    (error, value) => {
      if (error) { console.error('ics error:', error); return; }
      const blob = new Blob([value], { type: 'text/calendar;charset=utf-8' });
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `sessao-${dateStr}.ics`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      URL.revokeObjectURL(url);
    }
  );
}

/**
 * Retorna URL do Google Calendar com evento pré-preenchido.
 */
export function googleCalendarLink(session, sessionType, students, occurrenceDate) {
  const dateStr = occurrenceDate || session.date;
  const [year, month, day] = dateStr.split('-');
  const [hour, minute] = session.time.split(':');
  const startDT = `${year}${month}${day}T${hour}${minute}00`;

  const endMs = new Date(`${dateStr}T${session.time}:00`).getTime() + (Number(session.durationMin) || 60) * 60000;
  const endDate = new Date(endMs);
  const pad = n => String(n).padStart(2, '0');
  const endDT = `${endDate.getFullYear()}${pad(endDate.getMonth()+1)}${pad(endDate.getDate())}T${pad(endDate.getHours())}${pad(endDate.getMinutes())}00`;

  const title = session.title || sessionType?.name || 'Sessão';
  const details = students.map(s => s.name).join(', ');

  const params = new URLSearchParams({
    action: 'TEMPLATE',
    text: title,
    dates: `${startDT}/${endDT}`,
    details,
  });
  return `https://calendar.google.com/calendar/render?${params.toString()}`;
}
